/**
 * Utility for managing dynamic backend server URL in Retail POS.
 */

const DEFAULT_BACKEND_URL = 'http://75.119.130.59:8089';

/**
 * Sanitizes and cleans input URL strings.
 * Ensures protocol (http:// or https://) is present and strips trailing slashes.
 */
export const cleanUrl = (url) => {
  if (!url) return '';
  let cleaned = url.trim();
  if (!cleaned.startsWith('http://') && !cleaned.startsWith('https://')) {
    cleaned = `http://${cleaned}`;
  }
  return cleaned.replace(/\/+$/, '');
};

/**
 * Gets the active backend URL stored in localStorage or fallback default.
 */
export const getBackendUrl = () => {
  const storedUrl = localStorage.getItem('backend_url');
  if (storedUrl && storedUrl.trim()) {
    return cleanUrl(storedUrl);
  }
  return cleanUrl('http://157.173.96.252:8010');
};

/**
 * Sets and persists a new backend URL to localStorage.
 */
export const setBackendUrl = (url) => {
  const sanitized = cleanUrl(url);
  if (sanitized) {
    localStorage.setItem('backend_url', sanitized);
  }
  return sanitized;
};
